import {EventBus} from '@/services/EventBus'
export default {
    name: 'dropdown',
    data() {
        return {
            show: false,
        }
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    created() {
        EventBus.$on('root-click', this.closeOther)
    },
    beforeDestroy() {
        EventBus.$off('root-click', this.closeOther)
    },
    watch: {
        show() {
            this.$emit('change', this.show)
        },
    },
    methods: {
        toggle() {
            if (!this.disabled) {
                this.show = !this.show
            }
        },
        closeOther(el = null) {
            if (this.$el !== el && !this.$el.contains(el)) {
                this.show = false
            }
        },
    },
}



// WEBPACK FOOTER //
// ./src/components/ext/dropdown/dropdown.js